import { defineStore } from 'pinia'

export const useWidgetStore = defineStore('widget-store', {
  state: (): {
    token: string,
    orgId: string,
    returnUrl: string
  } => {
    return {
      token: '',
      orgId: '',
      returnUrl: ''
    }
  },
  actions: {
    setAuthToken(token: string) {
      this.token = token
    },
    setOrgId(orgId: string) {
      this.orgId = orgId
    },
    setReturnUrl(returnUrl: string) {
      this.returnUrl = returnUrl
    }
  },
})
